import React from 'react';
import NamePlate from './NamePlate';

const ShowFile = (props: any) => {
	const { file, previewFile, selectFile, showAssetsType } = props;
	const isImage = file?.type === 'image';
	return (
		<div className="file-wrapper" key={file?.id}>
			{isImage && (
				<img
					src={file?.assetUrl}
					alt={file?.fileName}
					className="file-image"
					onClick={previewFile.bind(null, file)}
				/>
			)}
			{!isImage && (
				<video
					src={file?.assetUrl}
					className="file-image"
					onClick={previewFile.bind(null, file)}
				/>
			)}
			<div className="f-selector">
				<input
					type="checkbox"
					checked={file?.isSelected}
					onChange={selectFile.bind(null, file)}
					disabled={!(file.type === showAssetsType || showAssetsType === 'all')}
				/>
			</div>
			<div className="file-name-plate" onClick={previewFile.bind(null, file)}>
				<NamePlate name={file?.fileName} />
			</div>
		</div>
	);
};

export default ShowFile;
